module.exports = __webpack_public_path__ + "static/media/optimal-online-logo-dark.aa3d865f.svg";